/**
 * Generated by orval v8.8.1 🍺
 * Do not edit manually.
 * Jobs API
 * API for listing scheduled jobs and requesting job execution
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";

/**
 * Retrieve all configured batch jobs and scheduling metadata
 * @summary Get scheduled jobs
 */
export const getJobs200ResponseDataJobsItemJobKeyMax = 100;

export const getJobs200ResponseDataJobsItemJobNameMax = 100;

export const getJobs200ResponseDataJobsItemCommandMax = 150;

export const getJobs200ResponseDataJobsItemJobGroupMax = 50;

export const getJobs200ResponseDataJobsItemScheduleTimeMax = 5;

export const GetJobs200Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        data: zod
            .object({
                jobs: zod
                    .array(
                        zod
                            .object({
                                job_id: zod.number(),
                                job_key: zod.string().max(getJobs200ResponseDataJobsItemJobKeyMax),
                                job_name: zod.string().max(getJobs200ResponseDataJobsItemJobNameMax),
                                command: zod.string().max(getJobs200ResponseDataJobsItemCommandMax),
                                descriptions: zod.string().optional(),
                                job_group: zod.string().max(getJobs200ResponseDataJobsItemJobGroupMax),
                                schedule_type: zod.enum(["hourly", "daily", "monthly"]),
                                schedule_time: zod
                                    .string()
                                    .max(getJobs200ResponseDataJobsItemScheduleTimeMax)
                                    .optional(),
                                schedule_day: zod.number().nullish(),
                                run_in_background: zod.number(),
                                without_overlapping: zod.number(),
                                on_one_server: zod.number(),
                                is_active: zod.number(),
                                job_status: zod.enum(["pending", "running", "finished", "failed"]).optional(),
                                started_at: zod.string().datetime({ offset: true }).nullish(),
                                ended_at: zod.string().datetime({ offset: true }).nullish(),
                                created_at: zod.string().datetime({ offset: true }).optional(),
                                updated_at: zod.string().datetime({ offset: true }).optional(),
                            })
                            .strict(),
                    )
                    .optional(),
            })
            .strict()
            .optional(),
    })
    .strict();

export const GetJobs400Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        status_code: zod.union([zod.number(), zod.null()]).optional(),
        errors: zod
            .union([zod.record(zod.string(), zod.union([zod.array(zod.string()), zod.string()])), zod.null()])
            .optional(),
    })
    .strict();

export const GetJobs401Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        status_code: zod.union([zod.number(), zod.null()]).optional(),
        errors: zod
            .union([zod.record(zod.string(), zod.union([zod.array(zod.string()), zod.string()])), zod.null()])
            .optional(),
    })
    .strict();

export const GetJobs403Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        status_code: zod.union([zod.number(), zod.null()]).optional(),
        errors: zod
            .union([zod.record(zod.string(), zod.union([zod.array(zod.string()), zod.string()])), zod.null()])
            .optional(),
    })
    .strict();

export const GetJobs422Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        status_code: zod.union([zod.number(), zod.null()]).optional(),
        errors: zod
            .union([zod.record(zod.string(), zod.union([zod.array(zod.string()), zod.string()])), zod.null()])
            .optional(),
    })
    .strict();

export const GetJobs500Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        status_code: zod.union([zod.number(), zod.null()]).optional(),
        errors: zod
            .union([zod.record(zod.string(), zod.union([zod.array(zod.string()), zod.string()])), zod.null()])
            .optional(),
    })
    .strict();

/**
 * Dispatch or run a specific job from dashboard/admin use cases
 * @summary Run job manually
 */
export const runJobPathJobKeyMax = 100;

export const RunJobParams = zod
    .object({
        job_key: zod.string().max(runJobPathJobKeyMax).describe("Job key"),
    })
    .strict();

export const runJobBodyDryRunDefault = 0;

export const RunJobBody = zod
    .object({
        dry_run: zod
            .union([zod.literal(0), zod.literal(1)])
            .default(runJobBodyDryRunDefault)
            .describe("Validate runnable condition without execution"),
    })
    .strict();

export const runJob200ResponseDataJobKeyMax = 100;

export const runJob200ResponseDataJobJobKeyMax = 100;

export const runJob200ResponseDataJobJobNameMax = 100;

export const runJob200ResponseDataJobCommandMax = 150;

export const runJob200ResponseDataJobJobGroupMax = 50;

export const runJob200ResponseDataJobScheduleTimeMax = 5;

export const RunJob200Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        data: zod
            .object({
                job_key: zod.string().max(runJob200ResponseDataJobKeyMax).optional(),
                queued: zod.union([zod.literal(0), zod.literal(1)]).optional(),
                requested_at: zod.string().datetime({ offset: true }).optional(),
                dry_run: zod
                    .union([zod.literal(0), zod.literal(1)])
                    .optional()
                    .describe("Present when request was validated in dry-run mode"),
                job_status: zod.enum(["pending", "running", "finished", "failed"]).optional(),
                started_at: zod.string().datetime({ offset: true }).nullish(),
                ended_at: zod.string().datetime({ offset: true }).nullish(),
                exit_code: zod.union([zod.number(), zod.null()]).optional(),
                job: zod
                    .object({
                        job_id: zod.number(),
                        job_key: zod.string().max(runJob200ResponseDataJobJobKeyMax),
                        job_name: zod.string().max(runJob200ResponseDataJobJobNameMax),
                        command: zod.string().max(runJob200ResponseDataJobCommandMax),
                        descriptions: zod.string().optional(),
                        job_group: zod.string().max(runJob200ResponseDataJobJobGroupMax),
                        schedule_type: zod.enum(["hourly", "daily", "monthly"]),
                        schedule_time: zod.string().max(runJob200ResponseDataJobScheduleTimeMax).optional(),
                        schedule_day: zod.number().nullish(),
                        run_in_background: zod.number(),
                        without_overlapping: zod.number(),
                        on_one_server: zod.number(),
                        is_active: zod.number(),
                        job_status: zod.enum(["pending", "running", "finished", "failed"]).optional(),
                        started_at: zod.string().datetime({ offset: true }).nullish(),
                        ended_at: zod.string().datetime({ offset: true }).nullish(),
                        created_at: zod.string().datetime({ offset: true }).optional(),
                        updated_at: zod.string().datetime({ offset: true }).optional(),
                    })
                    .strict()
                    .optional(),
            })
            .strict()
            .optional(),
    })
    .strict();

export const RunJob401Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        status_code: zod.union([zod.number(), zod.null()]).optional(),
        errors: zod
            .union([zod.record(zod.string(), zod.union([zod.array(zod.string()), zod.string()])), zod.null()])
            .optional(),
    })
    .strict();

export const RunJob403Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        status_code: zod.union([zod.number(), zod.null()]).optional(),
        errors: zod
            .union([zod.record(zod.string(), zod.union([zod.array(zod.string()), zod.string()])), zod.null()])
            .optional(),
    })
    .strict();

export const RunJob404Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        status_code: zod.union([zod.number(), zod.null()]).optional(),
        errors: zod
            .union([zod.record(zod.string(), zod.union([zod.array(zod.string()), zod.string()])), zod.null()])
            .optional(),
    })
    .strict();

export const RunJob422Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        status_code: zod.union([zod.number(), zod.null()]).optional(),
        errors: zod
            .union([zod.record(zod.string(), zod.union([zod.array(zod.string()), zod.string()])), zod.null()])
            .optional(),
    })
    .strict();

/**
 * Abort a running tracked job from dashboard/admin use cases
 * @summary Abort running job
 */
export const abortJobPathJobKeyMax = 100;

export const AbortJobParams = zod
    .object({
        job_key: zod.string().max(abortJobPathJobKeyMax).describe("Job key"),
    })
    .strict();

export const abortJob200ResponseDataJobKeyMax = 100;

export const abortJob200ResponseDataJobJobKeyMax = 100;

export const abortJob200ResponseDataJobJobNameMax = 100;

export const abortJob200ResponseDataJobCommandMax = 150;

export const abortJob200ResponseDataJobJobGroupMax = 50;

export const abortJob200ResponseDataJobScheduleTimeMax = 5;

export const AbortJob200Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        data: zod
            .object({
                job_key: zod.string().max(abortJob200ResponseDataJobKeyMax).optional(),
                pid: zod.number().optional(),
                job_status: zod.enum(["pending", "running", "finished", "failed"]).optional(),
                ended_at: zod.string().datetime({ offset: true }).nullish(),
                job: zod
                    .object({
                        job_id: zod.number(),
                        job_key: zod.string().max(abortJob200ResponseDataJobJobKeyMax),
                        job_name: zod.string().max(abortJob200ResponseDataJobJobNameMax),
                        command: zod.string().max(abortJob200ResponseDataJobCommandMax),
                        descriptions: zod.string().optional(),
                        job_group: zod.string().max(abortJob200ResponseDataJobJobGroupMax),
                        schedule_type: zod.enum(["hourly", "daily", "monthly"]),
                        schedule_time: zod.string().max(abortJob200ResponseDataJobScheduleTimeMax).optional(),
                        schedule_day: zod.number().nullish(),
                        run_in_background: zod.number(),
                        without_overlapping: zod.number(),
                        on_one_server: zod.number(),
                        is_active: zod.number(),
                        job_status: zod.enum(["pending", "running", "finished", "failed"]).optional(),
                        started_at: zod.string().datetime({ offset: true }).nullish(),
                        ended_at: zod.string().datetime({ offset: true }).nullish(),
                        created_at: zod.string().datetime({ offset: true }).optional(),
                        updated_at: zod.string().datetime({ offset: true }).optional(),
                    })
                    .strict()
                    .optional(),
            })
            .strict()
            .optional(),
    })
    .strict();

export const AbortJob401Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        status_code: zod.union([zod.number(), zod.null()]).optional(),
        errors: zod
            .union([zod.record(zod.string(), zod.union([zod.array(zod.string()), zod.string()])), zod.null()])
            .optional(),
    })
    .strict();

export const AbortJob403Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        status_code: zod.union([zod.number(), zod.null()]).optional(),
        errors: zod
            .union([zod.record(zod.string(), zod.union([zod.array(zod.string()), zod.string()])), zod.null()])
            .optional(),
    })
    .strict();

export const AbortJob404Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        status_code: zod.union([zod.number(), zod.null()]).optional(),
        errors: zod
            .union([zod.record(zod.string(), zod.union([zod.array(zod.string()), zod.string()])), zod.null()])
            .optional(),
    })
    .strict();

export const AbortJob409Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.enum(["Job is not running", "Running process is not tracked"]),
        data: zod
            .object({
                error_code: zod.enum(["job_not_running", "running_process_not_tracked"]),
            })
            .strict(),
    })
    .strict();

export const AbortJob500Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        status_code: zod.union([zod.number(), zod.null()]).optional(),
        errors: zod
            .union([zod.record(zod.string(), zod.union([zod.array(zod.string()), zod.string()])), zod.null()])
            .optional(),
    })
    .strict();

/**
 * Update Jobs.json runtime and schedule fields used by both the dashboard and Laravel scheduler
 * @summary Update job configuration fields
 */
export const updateJobPathJobKeyMax = 100;

export const UpdateJobParams = zod
    .object({
        job_key: zod.string().max(updateJobPathJobKeyMax).describe("Job key"),
    })
    .strict();

export const updateJobBodyScheduleTimeMax = 5;

export const updateJobBodyScheduleTimeRegExp = new RegExp("^[0-9]{2}:[0-9]{2}$");

export const UpdateJobBody = zod
    .object({
        job_status: zod.enum(["pending", "running", "finished", "failed"]).optional(),
        job_id: zod.number().optional(),
        started_at: zod.string().datetime({ offset: true }).nullish(),
        ended_at: zod.string().datetime({ offset: true }).nullish(),
        schedule_type: zod.enum(["hourly", "daily", "monthly"]).optional(),
        schedule_time: zod.string().max(updateJobBodyScheduleTimeMax).regex(updateJobBodyScheduleTimeRegExp).optional(),
        schedule_day: zod.number().nullish(),
        is_active: zod.number().optional(),
    })
    .strict();

export const updateJob200ResponseDataJobJobKeyMax = 100;

export const updateJob200ResponseDataJobJobNameMax = 100;

export const updateJob200ResponseDataJobCommandMax = 150;

export const updateJob200ResponseDataJobJobGroupMax = 50;

export const updateJob200ResponseDataJobScheduleTimeMax = 5;

export const UpdateJob200Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        data: zod
            .object({
                job: zod
                    .object({
                        job_id: zod.number(),
                        job_key: zod.string().max(updateJob200ResponseDataJobJobKeyMax),
                        job_name: zod.string().max(updateJob200ResponseDataJobJobNameMax),
                        command: zod.string().max(updateJob200ResponseDataJobCommandMax),
                        descriptions: zod.string().optional(),
                        job_group: zod.string().max(updateJob200ResponseDataJobJobGroupMax),
                        schedule_type: zod.enum(["hourly", "daily", "monthly"]),
                        schedule_time: zod.string().max(updateJob200ResponseDataJobScheduleTimeMax).optional(),
                        schedule_day: zod.number().nullish(),
                        run_in_background: zod.number(),
                        without_overlapping: zod.number(),
                        on_one_server: zod.number(),
                        is_active: zod.number(),
                        job_status: zod.enum(["pending", "running", "finished", "failed"]).optional(),
                        started_at: zod.string().datetime({ offset: true }).nullish(),
                        ended_at: zod.string().datetime({ offset: true }).nullish(),
                        created_at: zod.string().datetime({ offset: true }).optional(),
                        updated_at: zod.string().datetime({ offset: true }).optional(),
                    })
                    .strict()
                    .optional(),
            })
            .strict()
            .optional(),
    })
    .strict();

export const UpdateJob404Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        status_code: zod.union([zod.number(), zod.null()]).optional(),
        errors: zod
            .union([zod.record(zod.string(), zod.union([zod.array(zod.string()), zod.string()])), zod.null()])
            .optional(),
    })
    .strict();

export const UpdateJob422Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        status_code: zod.union([zod.number(), zod.null()]).optional(),
        errors: zod
            .union([zod.record(zod.string(), zod.union([zod.array(zod.string()), zod.string()])), zod.null()])
            .optional(),
    })
    .strict();
